/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Vchip_ViolenceInputs */

const en_subtitle_export_vchip_violence = /** @type {(inputs: Subtitle_Export_Vchip_ViolenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Violence/Fantasy Violence`)
};

const fr_subtitle_export_vchip_violence = /** @type {(inputs: Subtitle_Export_Vchip_ViolenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Violence/Violence fantastique`)
};

const de_subtitle_export_vchip_violence = /** @type {(inputs: Subtitle_Export_Vchip_ViolenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewalt/Fantasy-Gewalt`)
};

const it_subtitle_export_vchip_violence = /** @type {(inputs: Subtitle_Export_Vchip_ViolenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Violenza/Violenza fantastica`)
};

const ru_subtitle_export_vchip_violence = /** @type {(inputs: Subtitle_Export_Vchip_ViolenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Насилие/Фантастическое насилие`)
};

const es_subtitle_export_vchip_violence = /** @type {(inputs: Subtitle_Export_Vchip_ViolenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Violencia/Violencia de fantasía`)
};

const zh_cn2_subtitle_export_vchip_violence = /** @type {(inputs: Subtitle_Export_Vchip_ViolenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暴力/幻想暴力`)
};

const ja_subtitle_export_vchip_violence = /** @type {(inputs: Subtitle_Export_Vchip_ViolenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暴力／ファンタジー暴力`)
};

const hi_subtitle_export_vchip_violence = /** @type {(inputs: Subtitle_Export_Vchip_ViolenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हिंसा/काल्पनिक हिंसा`)
};

const pt_pt2_subtitle_export_vchip_violence = /** @type {(inputs: Subtitle_Export_Vchip_ViolenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Violência/Violência Fantástica`)
};

/**
* | output |
* | --- |
* | "Violence/Fantasy Violence" |
*
* @param {Subtitle_Export_Vchip_ViolenceInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_vchip_violence = /** @type {((inputs?: Subtitle_Export_Vchip_ViolenceInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Vchip_ViolenceInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_vchip_violence(inputs)
	if (locale === "de") return de_subtitle_export_vchip_violence(inputs)
	if (locale === "it") return it_subtitle_export_vchip_violence(inputs)
	if (locale === "ru") return ru_subtitle_export_vchip_violence(inputs)
	if (locale === "es") return es_subtitle_export_vchip_violence(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_vchip_violence(inputs)
	if (locale === "ja") return ja_subtitle_export_vchip_violence(inputs)
	if (locale === "hi") return hi_subtitle_export_vchip_violence(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_vchip_violence(inputs)
	return en_subtitle_export_vchip_violence(inputs)
});